import React from 'react';
import PropTypes from 'prop-types';

import { default as i18next } from 'i18next';
import { Trans, useTranslation } from 'react-i18next';
import BookingModel from '../../../models/bookingModel';

import { Divider, Table } from 'semantic-ui-react';

const TIME_OPTIONS = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
};

const Booking = ({ booking }) => {
    let bookingModel = new BookingModel(booking);
    if (bookingModel.isGA) {
        return 'General Admission';
    }

    return (
        <Trans
            i18nKey="swap_seat_info"
            values={{
                zone: bookingModel.zoneName,
                row: bookingModel.row,
                seat: bookingModel.seat,
                access: bookingModel.access
            }}
        >
            Zone: %zone% Access %access% Row %row% Seat %seat%
        </Trans>
    );
};

Booking.propTypes = {
    booking: PropTypes.object.isRequired
};

const User = ({ user }) => (
    <span>
        {`${user.first_name} ${user.last_name}`}
        <a href={`mailto:${user.email}`} target="_blank" rel="noopener noreferrer">
            {` (${user.email})`}
        </a>
    </span>
);

User.propTypes = {
    user: PropTypes.object.isRequired
};

export default function SwapHistoryRow({ event, row: { old_booking, new_booking, request_confirmed, request_user } }) {
    const { t } = useTranslation();
    let formatter = new Intl.DateTimeFormat([i18next.language, event.default_language, 'fr'], TIME_OPTIONS);
    return (
        <React.Fragment>
            <Divider horizontal>{formatter.format(new Date(request_confirmed))}</Divider>
            <Table celled definition>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{t('ticket.overview.dividerFrom')}</Table.Cell>
                        <Table.Cell>
                            <Booking booking={old_booking} />
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{t('ticket.overview.dividerTo')}</Table.Cell>
                        <Table.Cell>
                            <Booking booking={new_booking} />
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{t('ticket.attendee.operator')}</Table.Cell>
                        <Table.Cell>
                            <User user={request_user} />
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </React.Fragment>
    );
}

SwapHistoryRow.propTypes = {
    row: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired
};
